<template>
  <div class="component-container">
    <div class="container-head">
      <i class="iconfont icon-tongzhifankui"></i>
      <span>申请通知</span>
    </div>
    <div class="container-body">
      <div class="form-body">
        <el-table
          row-class-name="vertical-align-top"
          :data="discussMembers"
          :header-cell-style="{
            background: '#E5F5F9',
            fontSize: '16px',
            color: '#353739'
          }"
          :stripe="true"
        >
          <el-table-column
            sortable
            min-width="150"
            prop="userName"
            label="用户名"
          ></el-table-column>
          <el-table-column
            sortable
            min-width="150"
            prop="userId"
            label="手机号"
          ></el-table-column>
          <el-table-column
            sortable
            min-width="250"
            prop="postTitle"
            label="讨论标题"
          ></el-table-column>
          <el-table-column
            sortable
            min-width="150"
            align="center"
            prop="createTm"
            label="申请时间"
          >
            <template slot-scope="scope">
              <span> {{ scope.row.createTm | dateFormat }} </span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            min-width="150"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <button
                class="eims-button eims-button--text"
                @click="handleAgreeMember(scope.row)"
              >
                同意
              </button>
              <button
                class="eims-button eims-button--text"
                @click="handleRejectMember(scope.row)"
              >
                拒绝
              </button>
            </template>
          </el-table-column>
        </el-table>

        <span style="float: right">
          <el-pagination
            layout="sizes, prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :page-sizes="pagination.pageSizeArray"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            :current-page="pagination.currentPage"
          >
          </el-pagination>
        </span>
      </div>
    </div>

    <animation
      :loadingDataVisible="isLoading"
      :loadingText="loadingText"
    ></animation>
  </div>
</template>

<script>
import { Message } from "element-ui";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import animation from "@/components/loading/animation";
import {
  DIALOG_TYPE_ADD,
  DIALOG_TYPE_UPDATE,
  PAGE_SIZE_ARRAY
} from "@/constants/constants";
import { mapState } from "vuex";

export default {
  name: "ApplyNotice",
  components: { animation },

  data() {
    return {
      discussMembers: [],
      pagination: {
        total: 0,
        pageSize: 10,
        pageSizeArray: PAGE_SIZE_ARRAY,
        currentPage: 1
      },
      isLoading: false,
      loadingText: "加载中",
      avatarPre: window.config.api.baseUrl,
      //未审核
      APPROVE_STATUS_NOT: "0",
      //已通过
      APPROVE_STATUS_AGREE: "1",
      //已拒绝
      APPROVE_STATUS_REFUSE: "2"
    };
  },

  mounted() {
    this.initData();
  },

  methods: {
    handleAgreeMember(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          userId: row.userId,
          postCode: row.postCode,
          approveStatus: this.APPROVE_STATUS_AGREE
        }
      };

      this.handleRejectOrAgreeMember(obj);
    },

    handleRejectMember(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          userId: row.userId,
          postCode: row.postCode,
          approveStatus: this.APPROVE_STATUS_REFUSE
        }
      };

      this.handleRejectOrAgreeMember(obj);
    },

    handleRejectOrAgreeMember(obj) {
      this.isLoading = true;
      this.loadingText = "处理中";

      http
        .post(
          window.config.api.baseUrl + "/eims-api/discuss/approveMember",
          obj
        )
        .then(response => {
          if (response.data.code === "00000") {
            Message.success({ message: "操作成功" });
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.initData();
        });
    },

    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.initData();
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.initData();
    },

    initData() {
      this.loadingText = this.$options.data().loadingText;
      this.isLoading = true;
      let that = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/noticeApplyList", {
          token: cookie.getCookie("token"),
          data: {
            pageNum: that.pagination.currentPage,
            pageSize: that.pagination.pageSize
          }
        })
        .then(response => {
          let data = response.data.data;
          that.pagination.total = data.total;
          that.discussMembers = data.applyNotices;
        })
        .finally(() => {
          this.applyDialogVisible = false;
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
/deep/
  .form-body
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #f3fdff !important;
}

.eims-button--text {
  border-color: transparent;
  color: #409eff;
  background: transparent;
}

.user-avatar {
  background-size: cover;
  z-index: 10000;
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 2px solid rgba(234, 233, 233, 0.46);
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/ApplyNotice.vue